import type { ChatMessage, Conversation } from '@auw/workspace-utils';

const MAX_MESSAGES_PER_CONVERSATION = 400;
const MAX_LOADED_INACTIVE_CONVERSATIONS = 10;

export function persistMessagesToCache(conversationId: string, messages: ChatMessage[]): void {
  if (!conversationId || messages.length === 0) return;
  import('@auw/api-client').then(({ setCachedMessages }) => {
    void setCachedMessages(conversationId, messages);
  }).catch(() => {
    // 캐시 실패는 런타임 UX를 막지 않음
  });
}

export function clampMessages(messages: ChatMessage[]): ChatMessage[] {
  if (messages.length <= MAX_MESSAGES_PER_CONVERSATION) return messages;
  return messages.slice(-MAX_MESSAGES_PER_CONVERSATION);
}

export function applyConversationMemoryPolicy(
  conversations: Record<string, Conversation>,
  activeId: string | null,
): Record<string, Conversation> {
  let changed = false;
  const next: Record<string, Conversation> = { ...conversations };

  for (const [id, conversation] of Object.entries(next)) {
    if (conversation.messages.length <= MAX_MESSAGES_PER_CONVERSATION) continue;
    next[id] = {
      ...conversation,
      messages: conversation.messages.slice(-MAX_MESSAGES_PER_CONVERSATION),
    };
    changed = true;
  }

  const loadedInactive = Object.values(next)
    .filter((conversation) => (
      conversation.id !== activeId
      && conversation.historyLoaded
      && conversation.messages.length > 0
    ))
    .sort((a, b) => b.updatedAt - a.updatedAt);

  if (loadedInactive.length > MAX_LOADED_INACTIVE_CONVERSATIONS) {
    const victims = loadedInactive.slice(MAX_LOADED_INACTIVE_CONVERSATIONS);
    for (const victim of victims) {
      const previous = next[victim.id];
      if (!previous || previous.messages.length === 0) continue;
      persistMessagesToCache(victim.id, previous.messages);
      next[victim.id] = {
        ...previous,
        messages: [],
        historyLoaded: false,
      };
      changed = true;
    }
  }

  return changed ? next : conversations;
}
